<app-multiple-select
    [datasourceColumnId]="dashboardItem.datasourceColumnId"
    [dataLoaderData]="dataLoaderResult"
    [excludeMode]="isExcludeMode()"
    [splitable]="isSplitable()"
    [bucketable]="isBucketable()"
    [showQuickSelectionButtons]="isQuickSelectionButtons()"
    [selectMode]="dashboardItem.selectMode"
>
</app-multiple-select>
